// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cgO_X","headline":"_2-Tj_","border":"_1R1RG","login-prompt-wrapper":"_3kPpb"};